import styled from 'styled-components';

const Plus = ({ width = 22, height = 22, title = 'plus', ...props }) => (
  <svg width={width} height={height} {...props}>
    <title>{title}</title>
    <path d="M0,11 L22,11" stroke="#2F3F56" strokeWidth="2" />
    <path d="M11,0 L11,22" stroke="#2F3F56" strokeWidth="2" />
  </svg>
);

export default styled(Plus)``;
